import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LocalStorageService } from '../services/localstorage.service';

@Injectable()
export class RedirectGuard implements CanActivate {

  constructor(
    private _storage: LocalStorageService,
    private _api: ApiService,
    private _router: Router) {

  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
      return new Promise((resolve) => {
        const authenticated = !!this._storage.get('token');
        if (authenticated) {
          this._api.me
          .list()
          .subscribe(
            (data_me) => {
              this._router.navigate(['home']);
              resolve(false);
            },
            (errors) => {
              this._storage.clear();
              resolve(true);
            });
        } else {
          resolve(true);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/redirect.guard.ts